// The one client-side password rule (mirrors services/passwordPolicy.js on the
// server). Returns the first unmet requirement, or "" when it's acceptable.
export const getPasswordError = (password = "") => {
  if (password.length < 8) return "Password must be at least 8 characters long";
  if (!/[a-z]/.test(password))
    return "Password must include a lowercase letter";
  if (!/[A-Z]/.test(password))
    return "Password must include an uppercase letter";
  if (!/[0-9]/.test(password)) return "Password must include a number";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
    return "Password must include a special character";
  return "";
};
